import settingsModule from '../../settings.module';
import template from './settings.component.html';
import style from './settings.component.css';

export default settingsModule.component('settings', {
    template,
    style,
    bindings: {
        settingsItems: '<'
    },
    controller(navigationService) {
        const vm = this;
        vm.items = [];
        vm.navigationService = navigationService;
    }
});



// WEBPACK FOOTER //
// ./modules/settings/components/settings/settings.component.js